import React from "react";
import TeamMember from "./TeamMember";
// import './TeamList.css';
import "./TeamMember.css";

const teamMembers = [
  {
    name: "Amogha C J",
    role: "Business Architect",
    image: "./assets/team/amogha.png",
  },
  // {
  //   name: "Vinay B",
  //   role: "Project Manager",
  //   image: "./assets/team/vinay.png",
  // },
  { name: "Rashmi", role: "HR Manager", image: "./assets/team/rashmi.png" },
  // Add more team members as needed
];

const Team = () => {
  return (
    <>
      <h1 className="product-title mx-4">Team</h1>
      <div className="team-list">
        {teamMembers.map((member, index) => (
          <TeamMember key={index} {...member} />
        ))}
      </div>
    </>
  );
};

export default Team;
